import React from 'react';

export const TranslationContext = React.createContext( [] );

export function TranslationProvider( { children } ) {

    return <TranslationContext.Provider value={ {  } }>{ children }</TranslationContext.Provider>;
}
